import React from "react"
import PulseLoader from "react-spinners/PulseLoader"

export default class Spinner extends React.Component {
  render = () => {
    return (
      <div className="sweet-loading">
        <PulseLoader
          size={10}
          color={"#AAA"}
          loading={true}
        />
      </div>
    )
  }
}
